import { MetaTitle } from 'components/meta-title';
export default MetaTitle;
